import { render } from "./GaleriaView.vue?vue&type=template&id=a4b37b42&lang=true"
import script from "./GaleriaView.vue?vue&type=script&lang=js"
export * from "./GaleriaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__